import { render, staticRenderFns } from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm.vue?vue&type=template&id=5863da9a"
import script from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports